// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!./Themes.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/fonts/Helvetica.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../public/fonts/Helvetica.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../public/fonts/Helvetica.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../public/fonts/Helvetica.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../public/fonts/Helvetica.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../public/fonts/Helvetica.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../public/fonts/Helvetica-Bold-Font.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../public/fonts/Helvetica-Bold-Font.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../public/fonts/Helvetica-Bold-Font.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../public/fonts/Helvetica-Bold-Font.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../public/fonts/Helvetica-Bold-Font.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../public/fonts/Helvetica-Bold-Font.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Helvetica";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); /* IE9 Compat Modes */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), /* IE6-IE8 */
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("opentype"), /* Open Type Font */
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("svg"), /* Legacy iOS */ 
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype"), /* Safari, Android, iOS */
    url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff"), /* Modern Browsers */
    url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff2"); /* Modern Browsers */
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "Helvetica-Bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}); /* IE9 Compat Modes */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("embedded-opentype"), /* IE6-IE8 */
    url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("opentype"), /* Open Type Font */
    url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("svg"), /* Legacy iOS */
    url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("truetype"), /* Safari, Android, iOS */
    url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("woff"), /* Modern Browsers */
    url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("woff2"); /* Modern Browsers */
  font-weight: normal;
  font-style: normal;
}

html *
{
   font-family: "Helvetica";
   font-size: 14px;
}

input {
  padding: .5rem;
  width: 100%;
  display: block;
  border-radius: 4px;
  border: 1px solid #ccc;
  color:var(--signal34InputTextColor);
  background-color: var(--signal34InputBackgroundColor);
}

input:disabled {
  color:var(--signal34InputDisableTextColor);
  background-color: var(--signal34InputDisableBackgroundColor);
}

input:focus {
  border-color: #007eff;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
  0 0 0 3px rgba(0, 126, 255, 0.1);
  outline: none;
}

input.error {
  border-color: red;
}

label {
  font-weight: bold;
  display: block;
  margin-bottom: .5rem;
}

table {
  border-spacing:0px;
}

td, th {
  padding: 0;
}

/*
App.js
*/
.logo {
  padding-left: 8px;
  padding-right: 8px;
  position: relative;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.signal34-searchbar {
  display: table-cell;
  position: relative;
  width: 100%;
}
/* header, logo and buttons styles */
.signal34-header {
  z-index: 103;
  display: flex;
  cursor: pointer;
}

.signal34-logo-link{
  outline: none;
}

/* navigation */
.signal34-navigation {
  border-bottom: var(--signal34NavigationBar);
}

.signal34-navigation-more .dropdown-toggle:after {
  display: none;
}

.signal34-navigation-more.dropdown {
  position: unset;
  width: 54px;
}

.signal34-navigation-more.show.dropdown.nav-item .dropdown-toggle.nav-link,
.signal34-navigation-more.dropdown.nav-item .dropdown-toggle.nav-link {
  padding-left: 0px;
  outline: none;
}

/* Mobile */
@media only screen and (max-width: 679px) {
  .signal34-navigation .nav {
    padding-left: 9px;
  }
}

/* Desktop*/
@media only screen and (min-width: 680px) {
  .signal34-navigation .nav {
    padding-left: 70px;
  }
}

.signal34-navigation .nav:hover { 
  cursor: pointer;
}

.signal34-navigation .nav-pills .nav-link.active {
  color: var(--signal34NavigationTextColor);
  border-bottom: 3px solid var(--signal34NavigationBorderBotton);
  background-color: transparent;
  outline: none;
}

.signal34-navigation .nav-pills .nav-link {
  border-radius: unset;
  padding-left: 14px;
  padding-right: 18px;
}

.signal34-navigation .nav-pills .show > .nav-link {
  color: var(--signal34NavigationLinkColor);
  background-color: transparent;
  width: 100%;
}

.signal34-navigation a {
  color: var(--signal34NavigationLinkColor);
  text-decoration: none;
  font-size: 12px;
}

.signal34-navigation a:hover,
.signal34-navigation a:focus {
  color: var(--signal34NavigationLinkColor);
  background-color: transparent;
}

.signal34-navigation .dropdown-item.active,
.signal34-navigation .dropdown-item:active,
.signal34-navigation .dropdown-item.active:hover
.signal34-navigation .dropdown-item.active:focus {
  color: var(--signal34NavigationLinkColor);
  text-decoration: none;
  background-color: transparent;
  outline: none;
}

.signal34-navigation-menu {
  width: 16px;
  height: 16px;
  display: inline-block;
  font-size: 12px;
}

/* container */
.signal34-container {
  position: relative;
  display: block;
}

/* footer */
.signal34-footer {
  font-size: 8.8pt;
  position: relative;
  bottom: 0;
  display: inline-block;
  width: 100%;
  padding-bottom: 15px;
  padding-top: 43px;
}

.signal34-footer span,
.signal34-footer a{
  font-size: 8.8pt;
}

.container {
  width: 95%;
  position: relative;
}

.container-fluid h1{
  font-size: 18pt;
}

.container-fluid textarea{
  resize: none;
}

/*
Search.js
*/
.autocomplete-input > div{
  padding: 0;
  border: 0px solid;
  color: var(--primaryTextColor);
  background-color: var(--signal34SearchColor)
}

.search-elements {
  border: 1px solid var(--signal34SearchBorderColor);
  border-radius: 0.30rem;
  display: table;
  overflow-y: visible;
  width: 100%;
  border-collapse: unset;
  min-width: 40px ;
  margin-top: 8px ;
  margin-bottom: 8px;
  background-color: var(--signal34SearchColor);
}

.select-element{
  position: relative;
  display: table-cell;
  width: 100%;
}

.menu-element{
  display: table-cell;
  position: relative;
}

.autocomplete-input {
  background-color: transparent;
  display: block;
}
/*
SearchByTextFilter.js
*/
.checkboxes label {
  display: block;
  float: left;
  padding-right: 30px;
  white-space: nowrap;
}

.checkboxes input {
  vertical-align: middle;
  display: inline;
}

.checkboxes label span {
  vertical-align: middle;
}
.checkboxes .text-checkbox input[type="checkbox"]{
  width: 30px;
  display: inline;
  margin-bottom: 6px;
}

/*
Search.js
ContentItem.js
*/

.search-settings-menu-toggle {
  padding-left: 6px;
  padding-right:6px;
  border:none;
  opacity: .25;
  height: 40px;
  background-color: transparent;
}

@-moz-document url-prefix() {
  .search-settings-menu-toggle {
    padding-left: 6px;
    padding-right:6px;
    border:none;
    opacity: .25;
    background-color: transparent;
  }
}

.search-settings-menu-toggle img{
  width: 24px;
  height: 16px;
  margin-right: 6px;
  margin-bottom: 5px;
  filter: var(--signal34SearchSettingsMenuToggleFilter);
}

.search-settings-menu-toggle.btn-settings-menu:not(:disabled):not(.disabled):active:focus,
.search-settings-menu-toggle.btn-settings-menu,
.search-settings-menu-toggle.btn-settings-menu:active,
.search-settings-menu-toggle.btn-settings-menu:focus,
.search-settings-menu-toggle.btn-settings-menu:hover
.show > .search-settings-menu-toggle.btn-settings-menu:focus,
.show > .search-settings-menu-toggle.btn-settings-menu:active,
.show > .search-settings-menu-toggle.btn-settings-menu:hover{
  color: transparent;
  background-color: transparent;
  border-color: transparent;
  border: 4px solid transparent;
  -webkit-box-shadow: transparent 4px 4px 4px 4px inset;
  box-shadow: transparent 4px 4px 4px 4px inset;
}

.search-settings-menu-toggle.btn-settings-menu:disabled{
  opacity: .25;
}

.search-settings-menu-toggle:hover {
  background: transparent;
  opacity: 1.0;
}

.search-settings-menu-toggle:after
{
  content: none
}

/* disable style menu options of filter */
.dropdown-menu>.disabled>a, .dropdown-menu>.disabled>a:focus, .dropdown-menu>.disabled>a:hover {
  color: #777;
  cursor: pointer;
}

.search-settings-menu.dropdown{
  z-index:3;
}

/*
SearchSettings.js
*/
/* mobile */
@media only screen and (max-width: 679px) {
  .search-settings-modal-body {
    padding-left: 0rem;
  }
}
/* desktop */
@media only screen and (min-width: 680px) {
  .search-settings-modal-body {
    padding-left: 2rem;
  }
}
.search-settings-dialog {
  display: table;
}

.search-settings-dialog > div {
  display: table-row;
}

.search-settings-dialog .settings-label {
  padding-left: 10px;
  padding-right: 10px;
}

.search-settings-dialog .settings-checkbox {
  display: table-cell;
  width: 100px;
  padding-left: 18px;
}

.search-settings-dialog .sort-by {
  display: table-cell;
  width: 200px;
}

.search-settings-dialog .sort-order {
  display: table-cell;
  width: 200px;
}

.search-settings-dialog .per-page {
  display: table-cell;
  width: 100px ;
  padding-left: 18px;
}

/*
ContentAdd.js
ContentEdit.js
*/
.tags-text {
  display: inline;
  padding-left: 5px;
}

.tags-label,
.rating-label {
  display:  inline-block;;
}

.rating-box {
  display: inline;
  padding-left: 0px;
  padding-right: 18px;
  padding-top: 12px;
  padding-bottom: 12px;
}

.rating-box img {
  padding-top: 6px;
  padding-bottom: 6px;
  padding-left: 2px;
  padding-right: 12px;
}

.rating-box img:hover {
  cursor: pointer;
}

.modal-content{
  background-color: var(--signal34ModalBackgroundColor);
}

.modal-header{
  background-color: var(--signal34ModalHeaderColor);
}

.modal-add-content textarea{
  resize: vertical;
}

.modal-add-content .modal-content {
  overflow: visible;
}

.modal-embed-content .modal-content {
  overflow: visible;
}

.blank_row {
  height: 20px ;
}

@media only screen and (min-width: 680px) {
  .signal34-contents-grid .container {
    width: 95%;
    position: relative;
  }

  .modal-edit-content {
    display: inline-block;
    min-width: 570px;
  }

  .modal-edit-content textarea{
    min-width: 570px;
    resize: both;
    height: 115px;
  }

  .modal-edit-content.signal34-navigate{
    padding-top: 24px;
  }

  .empty-row {
    height: 20px ;
  }
  .modal-edit-content.modal-content-edit{
    display: inline-block;
    min-width: 570px;
    margin-top: 25px;
  }
}

@media only screen and (max-width: 679px) {
  .signal34-contents-grid .container {
    width: auto;
    position: relative;
  }

  .modal-edit-content {
    padding-top: 40px;
    display: inline-block;
    width: 100%;
  }

  .modal-edit-content textarea{
    resize: both;
    height: 115px;
    max-width: 100%;
  }
  ::-webkit-resizer { background: gray; }

  .empty-row {
    height: 0px ;
  }
}

.modal-edit-content .modal-content {
  overflow: visible;
}

label.form-label {
  font-family: "Helvetica" ;
  display: block;
  margin-bottom: .5rem;
}

label.form-label.tags-label {
  font-family: "Helvetica" ;
  display: inline-block;
  margin-bottom: .5rem;
}

.table td, .table th {
  padding: 5px;
}

.content-rating-label {
  float: left;
  width: 50%;
  display: block;
}

.content-checkbox .text-checkbox {
    display: block;
    float: right;
    width: auto;
}

.content-checkbox {
  float: right;
  display: block;
  width: 50%;
}

/*
ContentType.js
*/
.content-type-class {
  width: 45%;
}

/*
Subscription.js
SearchByTextFilter.js
*/
.text-checkbox {
  display: block;
  float: left;
  width: 100px;
}

.text-checkbox input[type="radio"],
.text-checkbox input[type="checkbox"]{
  width: 30px;
  display: inline;
}
.label-checkbox{
  float: left;
}

/* Menu actions*/
div.action-menu{
  display: block;
}

.fa-bars {
  opacity: .25;
}

.fa-bars:hover {
  opacity: 1.0;
}

.btn.active.focus, .btn.active:focus, .btn.focus, .btn.focus:active, .btn:active:focus, .btn:focus {
  outline-offset: -2px;
}

.actions-menu .dropdown-toggle:after {
  content: none
}

.actions-menu.dropdown {
  padding-left: 8px;
  padding-right: 8px;
  position: relative;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  z-index: 3;
}

.actions-menu .btn-action-menu {
  color: var(--signal34ActionsMenuColor);
  background-color: var(--signal34ActionsMenuBackgroundColor);
  border-color: var(--signal34ActionsMenuBorderColor);
  -webkit-box-shadow: transparent 4px 4px 4px 4px inset;
  box-shadow: transparent 4px 4px 4px 4px inset;

  display: inline-block;
  padding: 6px 12px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.show >.btn-action-menu.dropdown-toggle:focus
.show >.btn-action-menu.dropdown-toggle:focus,
.show >.btn-action-menu.dropdown-toggle:active,
.show >.btn-action-menu.dropdown-toggle:hover,
.show >.btn-action-menu.dropdown-toggle,
.open >.btn-action-menu.dropdown-toggle{
  color: #333;
  background-color: #d4d4d4;
  border-color: #8c8c8c;
  box-shadow: transparent 4px 4px 4px 4px inset;
}

.actions-menu .btn-action-menu:hover,
.actions-menu .btn-action-menu:focus,
.actions-menu .btn-action-menu:not(:disabled):not(.disabled):active{
  color: var(--signal34ActionsMenuColor);
  background-color: var(--signal34ActionsMenuBackgroundColor);
  border-color: var(--signal34ActionsMenuBorderColor);
  -webkit-box-shadow: transparent 4px 4px 4px 4px inset;
  box-shadow: transparent 4px 4px 4px 4px inset;
}

.actions-menu .btn-action-menu:disabled{
  opacity: .25;
}

.actions-menu:hover {
  opacity: 1.0;
}

.actions-menu .caret {
  display: none;
}

.actions-menu a {
  color:var(--primaryTextColor);
  text-decoration:none;
}

/*
Subscription.js
*/
.subscription-section {
  border-bottom: 2px solid var(--primaryTextColor);
}

.subscription-title span {
  font-size: 12pt;
  width: max-content;
  display: block;
}

.subscription-form {
  padding-left: 12px;
}

.imitate_link {
  color: var(--signal34LinkColor);
}

.imitate_link:hover {
  text-decoration: underline;
  cursor: pointer;
}

.glyphicon {
  font-family: 'Glyphicons Halflings' ;
}

/*
PayCreditCard.js
*/
.signal34-payment-button.btn-link{
  color: var(--signal34LinkColor);
  text-decoration: none;
  padding: 0px;
  font-size: 14px;
  padding: 0px;
  height: 22px;
}

.svg-container {
  width: 33px;
  height: 41px;
}

div.signal34-explore+p {
  height: 16px;
}

.signupbusiness-form .form-group {
  margin-bottom: 8px;
}

/*
Invoices
*/
.medium_blank_row {
  height: 10px;
}

.invoice-header {
  background-color: #2288EE;
  color: white;
}

.invoice-item {
  width: 200px;
  font-weight: bold;
}

.invoice-duration,
.invoice-price {
  width: 100px;
  font-weight: bold;
}

#invoice-to-print {
  backgroundColor: #f5f5f5;
  width: 210mm;
  minHeight: 297mm;
  marginLeft: auto;
  marginRight: auto;
}

.invoice_link,
.edit_link {
  cursor: pointer;
}

div.edit_link{
  padding-top: 2px;
  position: relative;
  float: right;
}

.location-class {
  display:inline-block;
}

.location-class:after{
  content: "*";
  color: red;
}

.location-class-left {
  display:inline-block;
}

.location-class-right{
  float: right;
  padding-bottom: 0px;
  margin-bottom: 0px;
}

.location-class-right .alert.alert-light.show {
  padding-bottom: 0px;
  margin-bottom: 8px;
  margin-top: 0px;
  border: 0px;
  color: red;
  background-color: transparent;
}

.location-class-right-options span{
  float: right;
  padding-left: 8px;
  padding-bottom: 0px;
  margin-bottom: 0px;
  color: #888888;
}

.location-class-right-options span:hover{
  cursor: pointer;
}

.edit-buttons {
  margin-top: 10px;
  float: right;
  width: 100%;
}

.edit-buttons button {
  margin-left: 5px;
}

.edit-buttons div{
  float: right;
}

.page-item.active .page-link {
  color: var(--signal34PageLinkColor);
  background-color:var(--signal34PageLinkBackgroundColor);
  border-color: var(--signal34PageLinkBorderColor);
  cursor: default;
  z-index: 0;
}

a.page-link {
  color: var(--signal34PageLinkBackgroundColor);
  background-color:  var(--primaryBackgroundColor);
}

.page-item.disabled .page-link{
  color: var(--signal34PageLinkDisabledTextColor);
  background-color:  var(--signal34PageLinkDisabledBackgroundColor);
}

.page-link {
  color: var(--signal34PageLinkBackgroundColor);
}

a {
  color: var(--signal34LinkColor);
  text-decoration: none;
}

.form-control {
  font-size: 14px;
  color: var(--primaryTextColor);
  background-color: var(--primaryBackgroundColor);
}

.form-control:hover,
.form-control:focus {
  color: var(--primaryTextColor);
  background-color: var(--primaryBackgroundColor);
}

.signal34-bnt-default{
  height: 34px;
  font-size: 14px;
  color: var(--signal34ButtonTextcolor);
  background-color: var(--signal34ButtonBackgroundColor);
  border-color: var(--signal34ButtonBorderColor);
}

.signal34-bnt-default.btn-outline-secondary:hover,
.signal34-bnt-default.btn-outline-secondary:focus,
.signal34-bnt-default.btn-outline-secondary:active:focus {
  color: var(--signal34ButtonTextcolor);
  background-color: var(--signal34ButtonHoverBackgroundColor);
  border-color:  var(--signal34ButtonHoverBorderColor);
  box-shadow: none;
}

.signal34-bnt-primary{
  height: 34px;
  font-size: 14px;
  color: #fff;
  background-color: #337ab7;
  border-color: #337ab7;
}

.signal34-bnt-primary.btn-primary:hover,
.signal34-bnt-primary.btn-primary:focus,
.signal34-bnt-primary.btn-primary:active:focus {
  color:#fff;
  background-color:#286090;
  border-color:#204d74;
  box-shadow: none;
}

.dropdown-item:active {
  color: var(--signal34ActionsMenuColor);
  background-color: var(--signal34DropDownItemBackgroundColor);
}

.dropdown-item:focus, .dropdown-item:hover {
  color: var(--signal34ActionsMenuColor);
  text-decoration: none;
  background-color: var(--signal34DropDownItemBackgroundColor);
}

.dropdown-item{
  color: var(--signal34ActionsMenuColor);
}

.modal-add-content .modal-dialog {
  margin: 30px auto;
}

.modal-embed-content .modal-dialog {
  margin: 30px auto;
}

@media (min-width: 680px){
  .modal-add-content .modal-dialog {
    max-width: 600px;
  }
  .modal-embed-content .modal-dialog {
    max-width: 600px;
  }
}
.modal-title {
  font-size: 18px;
  font-family: "Helvetica";
}

.modal-header .close span {
  font-size: 21px;
  font-weight: 700;
  line-height: 1;
  color: var(--signal34ModalCloseColor);
  text-shadow: 0 1px 0 #fff;
}

.alert.alert-light.show {
  font-size: 14px;
  padding-bottom: 10px;
  color: red;
  margin-top: 5px;
  margin-bottom: 10px;
  padding-top: 0px;
  padding-left: 0px;
  padding-right: 0px;
  border-color: transparent;
  background-color: transparent;
}

.signal34-popover-error{
  color: red;
}

a:not([href]).invoice_link {
  color: var(--signal34LinkColor);
}

a:not([href]).invoice_link {
  color: var(--signal34LinkColor);
}

.dropdown-menu.show {
  background-color: var(--primaryBackgroundColor);
  color: var(--primaryTextColor);
  border-color: var(--signal34ActionsMenuBorderColor);
}

.dropdown-menu {
  min-width: 5rem;
}

.notes-counter-chars{
  color:#999;
  float: right;
  font-size: 14px;
  font-weight: normal;
  padding-top: 3px;
  margin: 0px;
}

.no-lr-padding {
  padding-left: 4px;
  padding-right: 4px;
}

/*
  Update Method Payment
*/
.signal34-update-payment-container {
  width: fit-content;
}

.signal34-update-payment-button-container {
  display: block;
  float: right;
  padding-left: 15px;
}

.login-indent {
  text-indent: 5.5em;
}

/* Desktop*/
@media only screen and (min-width: 680px) {
  .signal34-bnt-sign-in.btn-primary{
    font-size: 14px;
    color: #fff;
    background-color: #337ab7;
    border-color: #337ab7;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 5px;
    position: relative;
    top: 50%;
    text-align: center;
    width: 95px;
    height: 30px;
    margin-left: 18px;
    margin-right: 18px;
    font-weight: bold;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    z-index: 3;
  }
}

.signal34-bnt-sign-in.btn-primary:hover,
.signal34-bnt-sign-in.btn-primary:focus,
.signal34-bnt-sign-in.btn-primary:active:focus {
  color:#fff;
  background-color:#286090;
  border-color:#204d74;
  box-shadow: none;
}

/* for mobile*/
@media only screen and (max-width: 679px) {
  .signal34-bnt-sign-in.btn-primary{
    font-size: 14px;
    color: #fff;
    background-color: #337ab7;
    border-color: #337ab7;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 5px;
    position: relative;
    top: 50%;
    text-align: center;
    width: max-content;
    height: 30px;
    margin-left: 5px;
    margin-right: 5px;
    font-weight: bold;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    z-index: 3;
  }
}

/*share Dialog*/
.share-row {
  float: left;
  width: 100%;
  display: block;
  padding: 5px;
}

.share-label {
  float: left;
  display: block;
  width: 10%;
  padding: 5px;
}

.share-input {
  float: left;
  display: block;
  width: 80%;
  padding-right: 15px;
}

.share-button {
  float: right;
  display: block;
  width: 10%;
}

.share-social-icons {
  width: 100%;
  display: block;
}

.share-dialog {
  display: block;
  padding: 10px;
}

.share-social-button {
  padding: 2px;
  float: left;
}

.share-social-icon {
  fill: rgb(117, 117, 117);
}

.share-input .form-control[readonly] {
  color:rgb(117, 117, 117);
  background: white
}

/* for mobile*/
@media only screen and (max-width: 679px) {
  .share-label {
    float: left;
    display: block;
    width: 15%;
  }
  
  .share-input {
    float: left;
    display: block;
    width: 65%;
  }
  
  .share-button {
    float: right;
    display: block;
    width: 20%;
  } 
 }

 .embed-row {
  padding-top: 8px;
 }

 /* datepicker*/
 .DayPicker-Months {
   background-color: var(--primaryBackgroundColor);
 }

 .DayPicker-Day:hover,
 .DayPicker-Day:focus {
   color: var(--signal34DatePickerDayColorFocus)
 }`, "",{"version":3,"sources":["webpack://./src/styles/App.css"],"names":[],"mappings":"AAEA;EACE,wBAAwB;EACxB,4CAA4C,EAAE,qBAAqB;EACnE;;;;;2DAK2D,EAAE,oBAAoB;EACjF,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,4CAAsD,EAAE,qBAAqB;EAC7E;;;;;4DAKqE,EAAE,oBAAoB;EAC3F,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;GAEG,wBAAwB;GACxB,eAAe;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,mCAAmC;EACnC,qDAAqD;AACvD;;AAEA;EACE,0CAA0C;EAC1C,4DAA4D;AAC9D;;AAEA;EACE,qBAAqB;EACrB;kCACgC;EAChC,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;;CAEC;AACD;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,mCAAmC;EACnC,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;AACA,oCAAoC;AACpC;EACE,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA,eAAe;AACf;EACE,2CAA2C;AAC7C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,iBAAiB;EACjB,aAAa;AACf;;AAEA,WAAW;AACX;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,WAAW;AACX;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,8DAA8D;EAC9D,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,yCAAyC;EACzC,qBAAqB;EACrB,eAAe;AACjB;;AAEA;;EAEE,yCAAyC;EACzC,6BAA6B;AAC/B;;AAEA;;;;EAIE,yCAAyC;EACzC,qBAAqB;EACrB,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,qBAAqB;EACrB,WAAW;EACX,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;;CAEC;AACD;EACE,UAAU;EACV,iBAAiB;EACjB,8BAA8B;EAC9B;AACF;;AAEA;EACE,kDAAkD;EAClD,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;AACA;;CAEC;AACD;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;;;CAGC;;AAED;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE;IACE,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,6BAA6B;EAC/B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;;;;;;;;EAQE,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,6BAA6B;EAC7B,qDAAqD;EACrD,6CAA6C;AAC/C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;;EAEE;AACF;;AAEA,yCAAyC;AACzC;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;;CAEC;AACD,WAAW;AACX;EACE;IACE,kBAAkB;EACpB;AACF;AACA,YAAY;AACZ;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;;;CAGC;AACD;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;EACA;IACE,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;IACrB,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,eAAe;EACjB;EACA,oBAAoB,gBAAgB,EAAE;;EAEtC;IACE,YAAY;EACd;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,UAAU;EACV,cAAc;AAChB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,WAAW;AACf;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,UAAU;AACZ;;AAEA;;CAEC;AACD;EACE,UAAU;AACZ;;AAEA;;;CAGC;AACD;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,eAAe;AACjB;AACA;EACE,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE;AACF;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,mCAAmC;EACnC,+BAA+B;EAC/B,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,sCAAsC;EACtC,2DAA2D;EAC3D,mDAAmD;EACnD,qDAAqD;EACrD,6CAA6C;;EAE7C,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,8BAA8B;EAC9B,0BAA0B;EAC1B,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;;;;;EAME,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;;;EAGE,sCAAsC;EACtC,2DAA2D;EAC3D,mDAAmD;EACnD,qDAAqD;EACrD,6CAA6C;AAC/C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;;CAEC;AACD;EACE,gDAAgD;AAClD;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;CAEC;AACD;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;CAEC;AACD;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;EAEE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,uDAAuD;EACvD,gDAAgD;EAChD,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,6CAA6C;EAC7C,gDAAgD;AAClD;;AAEA;EACE,+CAA+C;EAC/C,iEAAiE;AACnE;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,+CAA+C;AACjD;;AAEA;;EAEE,8BAA8B;EAC9B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,sDAAsD;EACtD,8CAA8C;AAChD;;AAEA;;;EAGE,qCAAqC;EACrC,2DAA2D;EAC3D,oDAAoD;EACpD,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,UAAU;EACV,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,4DAA4D;AAC9D;;AAEA;EACE,sCAAsC;EACtC,qBAAqB;EACrB,4DAA4D;AAC9D;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+CAA+C;EAC/C,8BAA8B;EAC9B,mDAAmD;AACrD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;CAEC;AACD;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE;IACE,eAAe;IACf,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,QAAQ;IACR,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,mCAAmC;IACnC,+BAA+B;IAC/B,2BAA2B;IAC3B,UAAU;EACZ;AACF;;AAEA;;;EAGE,UAAU;EACV,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE;IACE,eAAe;IACf,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,QAAQ;IACR,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,mCAAmC;IACnC,+BAA+B;IAC/B,2BAA2B;IAC3B,UAAU;EACZ;AACF;;AAEA,eAAe;AACf;EACE,WAAW;EACX,WAAW;EACX,cAAc;EACd,YAAY;AACd;;AAEA;EACE,WAAW;EACX,cAAc;EACd,UAAU;EACV,YAAY;AACd;;AAEA;EACE,WAAW;EACX,cAAc;EACd,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB;AACF;;AAEA,cAAc;AACd;EACE;IACE,WAAW;IACX,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,cAAc;IACd,UAAU;EACZ;CACD;;CAEA;EACC,gBAAgB;CACjB;;CAEA,cAAc;CACd;GACE,+CAA+C;CACjD;;CAEA;;GAEE;CACF","sourcesContent":["@import './Themes.css';\n\n@font-face {\n  font-family: \"Helvetica\";\n  src: url(\"../../public/fonts/Helvetica.eot\"); /* IE9 Compat Modes */\n  src: url(\"../../public/fonts/Helvetica.eot?#iefix\") format(\"embedded-opentype\"), /* IE6-IE8 */\n    url(\"../../public/fonts/Helvetica.otf\") format(\"opentype\"), /* Open Type Font */\n    url(\"../../public/fonts/Helvetica.svg\") format(\"svg\"), /* Legacy iOS */ \n    url(\"../../public/fonts/Helvetica.ttf\") format(\"truetype\"), /* Safari, Android, iOS */\n    url(\"../../public/fonts/Helvetica.woff\") format(\"woff\"), /* Modern Browsers */\n    url(\"../../public/fonts/Helvetica.woff2\") format(\"woff2\"); /* Modern Browsers */\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Helvetica-Bold\";\n  src: url(\"../../public/fonts/Helvetica-Bold-Font.eot\"); /* IE9 Compat Modes */\n  src: url(\"../../public/fonts/Helvetica-Bold-Font.eot?#iefix\") format(\"embedded-opentype\"), /* IE6-IE8 */\n    url(\"../../public/fonts/Helvetica-Bold-Font.otf\") format(\"opentype\"), /* Open Type Font */\n    url(\"../../public/fonts/Helvetica-Bold-Font.svg\") format(\"svg\"), /* Legacy iOS */\n    url(\"../../public/fonts/Helvetica-Bold-Font.ttf\") format(\"truetype\"), /* Safari, Android, iOS */\n    url(\"../../public/fonts/Helvetica-Bold-Font.woff\") format(\"woff\"), /* Modern Browsers */\n    url(\"../../public/fonts/Helvetica-Bold-Font.woff2\") format(\"woff2\"); /* Modern Browsers */\n  font-weight: normal;\n  font-style: normal;\n}\n\nhtml *\n{\n   font-family: \"Helvetica\";\n   font-size: 14px;\n}\n\ninput {\n  padding: .5rem;\n  width: 100%;\n  display: block;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  color:var(--signal34InputTextColor);\n  background-color: var(--signal34InputBackgroundColor);\n}\n\ninput:disabled {\n  color:var(--signal34InputDisableTextColor);\n  background-color: var(--signal34InputDisableBackgroundColor);\n}\n\ninput:focus {\n  border-color: #007eff;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),\n  0 0 0 3px rgba(0, 126, 255, 0.1);\n  outline: none;\n}\n\ninput.error {\n  border-color: red;\n}\n\nlabel {\n  font-weight: bold;\n  display: block;\n  margin-bottom: .5rem;\n}\n\ntable {\n  border-spacing:0px;\n}\n\ntd, th {\n  padding: 0;\n}\n\n/*\nApp.js\n*/\n.logo {\n  padding-left: 8px;\n  padding-right: 8px;\n  position: relative;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n\n.signal34-searchbar {\n  display: table-cell;\n  position: relative;\n  width: 100%;\n}\n/* header, logo and buttons styles */\n.signal34-header {\n  z-index: 103;\n  display: flex;\n  cursor: pointer;\n}\n\n.signal34-logo-link{\n  outline: none;\n}\n\n/* navigation */\n.signal34-navigation {\n  border-bottom: var(--signal34NavigationBar);\n}\n\n.signal34-navigation-more .dropdown-toggle:after {\n  display: none;\n}\n\n.signal34-navigation-more.dropdown {\n  position: unset;\n  width: 54px;\n}\n\n.signal34-navigation-more.show.dropdown.nav-item .dropdown-toggle.nav-link,\n.signal34-navigation-more.dropdown.nav-item .dropdown-toggle.nav-link {\n  padding-left: 0px;\n  outline: none;\n}\n\n/* Mobile */\n@media only screen and (max-width: 679px) {\n  .signal34-navigation .nav {\n    padding-left: 9px;\n  }\n}\n\n/* Desktop*/\n@media only screen and (min-width: 680px) {\n  .signal34-navigation .nav {\n    padding-left: 70px;\n  }\n}\n\n.signal34-navigation .nav:hover { \n  cursor: pointer;\n}\n\n.signal34-navigation .nav-pills .nav-link.active {\n  color: var(--signal34NavigationTextColor);\n  border-bottom: 3px solid var(--signal34NavigationBorderBotton);\n  background-color: transparent;\n  outline: none;\n}\n\n.signal34-navigation .nav-pills .nav-link {\n  border-radius: unset;\n  padding-left: 14px;\n  padding-right: 18px;\n}\n\n.signal34-navigation .nav-pills .show > .nav-link {\n  color: var(--signal34NavigationLinkColor);\n  background-color: transparent;\n  width: 100%;\n}\n\n.signal34-navigation a {\n  color: var(--signal34NavigationLinkColor);\n  text-decoration: none;\n  font-size: 12px;\n}\n\n.signal34-navigation a:hover,\n.signal34-navigation a:focus {\n  color: var(--signal34NavigationLinkColor);\n  background-color: transparent;\n}\n\n.signal34-navigation .dropdown-item.active,\n.signal34-navigation .dropdown-item:active,\n.signal34-navigation .dropdown-item.active:hover\n.signal34-navigation .dropdown-item.active:focus {\n  color: var(--signal34NavigationLinkColor);\n  text-decoration: none;\n  background-color: transparent;\n  outline: none;\n}\n\n.signal34-navigation-menu {\n  width: 16px;\n  height: 16px;\n  display: inline-block;\n  font-size: 12px;\n}\n\n/* container */\n.signal34-container {\n  position: relative;\n  display: block;\n}\n\n/* footer */\n.signal34-footer {\n  font-size: 8.8pt;\n  position: relative;\n  bottom: 0;\n  display: inline-block;\n  width: 100%;\n  padding-bottom: 15px;\n  padding-top: 43px;\n}\n\n.signal34-footer span,\n.signal34-footer a{\n  font-size: 8.8pt;\n}\n\n.container {\n  width: 95%;\n  position: relative;\n}\n\n.container-fluid h1{\n  font-size: 18pt;\n}\n\n.container-fluid textarea{\n  resize: none;\n}\n\n/*\nSearch.js\n*/\n.autocomplete-input > div{\n  padding: 0;\n  border: 0px solid;\n  color: var(--primaryTextColor);\n  background-color: var(--signal34SearchColor)\n}\n\n.search-elements {\n  border: 1px solid var(--signal34SearchBorderColor);\n  border-radius: 0.30rem;\n  display: table;\n  overflow-y: visible;\n  width: 100%;\n  border-collapse: unset;\n  min-width: 40px ;\n  margin-top: 8px ;\n  margin-bottom: 8px;\n  background-color: var(--signal34SearchColor);\n}\n\n.select-element{\n  position: relative;\n  display: table-cell;\n  width: 100%;\n}\n\n.menu-element{\n  display: table-cell;\n  position: relative;\n}\n\n.autocomplete-input {\n  background-color: transparent;\n  display: block;\n}\n/*\nSearchByTextFilter.js\n*/\n.checkboxes label {\n  display: block;\n  float: left;\n  padding-right: 30px;\n  white-space: nowrap;\n}\n\n.checkboxes input {\n  vertical-align: middle;\n  display: inline;\n}\n\n.checkboxes label span {\n  vertical-align: middle;\n}\n.checkboxes .text-checkbox input[type=\"checkbox\"]{\n  width: 30px;\n  display: inline;\n  margin-bottom: 6px;\n}\n\n/*\nSearch.js\nContentItem.js\n*/\n\n.search-settings-menu-toggle {\n  padding-left: 6px;\n  padding-right:6px;\n  border:none;\n  opacity: .25;\n  height: 40px;\n  background-color: transparent;\n}\n\n@-moz-document url-prefix() {\n  .search-settings-menu-toggle {\n    padding-left: 6px;\n    padding-right:6px;\n    border:none;\n    opacity: .25;\n    background-color: transparent;\n  }\n}\n\n.search-settings-menu-toggle img{\n  width: 24px;\n  height: 16px;\n  margin-right: 6px;\n  margin-bottom: 5px;\n  filter: var(--signal34SearchSettingsMenuToggleFilter);\n}\n\n.search-settings-menu-toggle.btn-settings-menu:not(:disabled):not(.disabled):active:focus,\n.search-settings-menu-toggle.btn-settings-menu,\n.search-settings-menu-toggle.btn-settings-menu:active,\n.search-settings-menu-toggle.btn-settings-menu:focus,\n.search-settings-menu-toggle.btn-settings-menu:hover\n.show > .search-settings-menu-toggle.btn-settings-menu:focus,\n.show > .search-settings-menu-toggle.btn-settings-menu:active,\n.show > .search-settings-menu-toggle.btn-settings-menu:hover{\n  color: transparent;\n  background-color: transparent;\n  border-color: transparent;\n  border: 4px solid transparent;\n  -webkit-box-shadow: transparent 4px 4px 4px 4px inset;\n  box-shadow: transparent 4px 4px 4px 4px inset;\n}\n\n.search-settings-menu-toggle.btn-settings-menu:disabled{\n  opacity: .25;\n}\n\n.search-settings-menu-toggle:hover {\n  background: transparent;\n  opacity: 1.0;\n}\n\n.search-settings-menu-toggle:after\n{\n  content: none\n}\n\n/* disable style menu options of filter */\n.dropdown-menu>.disabled>a, .dropdown-menu>.disabled>a:focus, .dropdown-menu>.disabled>a:hover {\n  color: #777;\n  cursor: pointer;\n}\n\n.search-settings-menu.dropdown{\n  z-index:3;\n}\n\n/*\nSearchSettings.js\n*/\n/* mobile */\n@media only screen and (max-width: 679px) {\n  .search-settings-modal-body {\n    padding-left: 0rem;\n  }\n}\n/* desktop */\n@media only screen and (min-width: 680px) {\n  .search-settings-modal-body {\n    padding-left: 2rem;\n  }\n}\n.search-settings-dialog {\n  display: table;\n}\n\n.search-settings-dialog > div {\n  display: table-row;\n}\n\n.search-settings-dialog .settings-label {\n  padding-left: 10px;\n  padding-right: 10px;\n}\n\n.search-settings-dialog .settings-checkbox {\n  display: table-cell;\n  width: 100px;\n  padding-left: 18px;\n}\n\n.search-settings-dialog .sort-by {\n  display: table-cell;\n  width: 200px;\n}\n\n.search-settings-dialog .sort-order {\n  display: table-cell;\n  width: 200px;\n}\n\n.search-settings-dialog .per-page {\n  display: table-cell;\n  width: 100px ;\n  padding-left: 18px;\n}\n\n/*\nContentAdd.js\nContentEdit.js\n*/\n.tags-text {\n  display: inline;\n  padding-left: 5px;\n}\n\n.tags-label,\n.rating-label {\n  display:  inline-block;;\n}\n\n.rating-box {\n  display: inline;\n  padding-left: 0px;\n  padding-right: 18px;\n  padding-top: 12px;\n  padding-bottom: 12px;\n}\n\n.rating-box img {\n  padding-top: 6px;\n  padding-bottom: 6px;\n  padding-left: 2px;\n  padding-right: 12px;\n}\n\n.rating-box img:hover {\n  cursor: pointer;\n}\n\n.modal-content{\n  background-color: var(--signal34ModalBackgroundColor);\n}\n\n.modal-header{\n  background-color: var(--signal34ModalHeaderColor);\n}\n\n.modal-add-content textarea{\n  resize: vertical;\n}\n\n.modal-add-content .modal-content {\n  overflow: visible;\n}\n\n.modal-embed-content .modal-content {\n  overflow: visible;\n}\n\n.blank_row {\n  height: 20px ;\n}\n\n@media only screen and (min-width: 680px) {\n  .signal34-contents-grid .container {\n    width: 95%;\n    position: relative;\n  }\n\n  .modal-edit-content {\n    display: inline-block;\n    min-width: 570px;\n  }\n\n  .modal-edit-content textarea{\n    min-width: 570px;\n    resize: both;\n    height: 115px;\n  }\n\n  .modal-edit-content.signal34-navigate{\n    padding-top: 24px;\n  }\n\n  .empty-row {\n    height: 20px ;\n  }\n  .modal-edit-content.modal-content-edit{\n    display: inline-block;\n    min-width: 570px;\n    margin-top: 25px;\n  }\n}\n\n@media only screen and (max-width: 679px) {\n  .signal34-contents-grid .container {\n    width: auto;\n    position: relative;\n  }\n\n  .modal-edit-content {\n    padding-top: 40px;\n    display: inline-block;\n    width: 100%;\n  }\n\n  .modal-edit-content textarea{\n    resize: both;\n    height: 115px;\n    max-width: 100%;\n  }\n  ::-webkit-resizer { background: gray; }\n\n  .empty-row {\n    height: 0px ;\n  }\n}\n\n.modal-edit-content .modal-content {\n  overflow: visible;\n}\n\nlabel.form-label {\n  font-family: \"Helvetica\" ;\n  display: block;\n  margin-bottom: .5rem;\n}\n\nlabel.form-label.tags-label {\n  font-family: \"Helvetica\" ;\n  display: inline-block;\n  margin-bottom: .5rem;\n}\n\n.table td, .table th {\n  padding: 5px;\n}\n\n.content-rating-label {\n  float: left;\n  width: 50%;\n  display: block;\n}\n\n.content-checkbox .text-checkbox {\n    display: block;\n    float: right;\n    width: auto;\n}\n\n.content-checkbox {\n  float: right;\n  display: block;\n  width: 50%;\n}\n\n/*\nContentType.js\n*/\n.content-type-class {\n  width: 45%;\n}\n\n/*\nSubscription.js\nSearchByTextFilter.js\n*/\n.text-checkbox {\n  display: block;\n  float: left;\n  width: 100px;\n}\n\n.text-checkbox input[type=\"radio\"],\n.text-checkbox input[type=\"checkbox\"]{\n  width: 30px;\n  display: inline;\n}\n.label-checkbox{\n  float: left;\n}\n\n/* Menu actions*/\ndiv.action-menu{\n  display: block;\n}\n\n.fa-bars {\n  opacity: .25;\n}\n\n.fa-bars:hover {\n  opacity: 1.0;\n}\n\n.btn.active.focus, .btn.active:focus, .btn.focus, .btn.focus:active, .btn:active:focus, .btn:focus {\n  outline-offset: -2px;\n}\n\n.actions-menu .dropdown-toggle:after {\n  content: none\n}\n\n.actions-menu.dropdown {\n  padding-left: 8px;\n  padding-right: 8px;\n  position: relative;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n  z-index: 3;\n}\n\n.actions-menu .btn-action-menu {\n  color: var(--signal34ActionsMenuColor);\n  background-color: var(--signal34ActionsMenuBackgroundColor);\n  border-color: var(--signal34ActionsMenuBorderColor);\n  -webkit-box-shadow: transparent 4px 4px 4px 4px inset;\n  box-shadow: transparent 4px 4px 4px 4px inset;\n\n  display: inline-block;\n  padding: 6px 12px;\n  margin-bottom: 0;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.42857143;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  -ms-touch-action: manipulation;\n  touch-action: manipulation;\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  background-image: none;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.show >.btn-action-menu.dropdown-toggle:focus\n.show >.btn-action-menu.dropdown-toggle:focus,\n.show >.btn-action-menu.dropdown-toggle:active,\n.show >.btn-action-menu.dropdown-toggle:hover,\n.show >.btn-action-menu.dropdown-toggle,\n.open >.btn-action-menu.dropdown-toggle{\n  color: #333;\n  background-color: #d4d4d4;\n  border-color: #8c8c8c;\n  box-shadow: transparent 4px 4px 4px 4px inset;\n}\n\n.actions-menu .btn-action-menu:hover,\n.actions-menu .btn-action-menu:focus,\n.actions-menu .btn-action-menu:not(:disabled):not(.disabled):active{\n  color: var(--signal34ActionsMenuColor);\n  background-color: var(--signal34ActionsMenuBackgroundColor);\n  border-color: var(--signal34ActionsMenuBorderColor);\n  -webkit-box-shadow: transparent 4px 4px 4px 4px inset;\n  box-shadow: transparent 4px 4px 4px 4px inset;\n}\n\n.actions-menu .btn-action-menu:disabled{\n  opacity: .25;\n}\n\n.actions-menu:hover {\n  opacity: 1.0;\n}\n\n.actions-menu .caret {\n  display: none;\n}\n\n.actions-menu a {\n  color:var(--primaryTextColor);\n  text-decoration:none;\n}\n\n/*\nSubscription.js\n*/\n.subscription-section {\n  border-bottom: 2px solid var(--primaryTextColor);\n}\n\n.subscription-title span {\n  font-size: 12pt;\n  width: max-content;\n  display: block;\n}\n\n.subscription-form {\n  padding-left: 12px;\n}\n\n.imitate_link {\n  color: var(--signal34LinkColor);\n}\n\n.imitate_link:hover {\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.glyphicon {\n  font-family: 'Glyphicons Halflings' ;\n}\n\n/*\nPayCreditCard.js\n*/\n.signal34-payment-button.btn-link{\n  color: var(--signal34LinkColor);\n  text-decoration: none;\n  padding: 0px;\n  font-size: 14px;\n  padding: 0px;\n  height: 22px;\n}\n\n.svg-container {\n  width: 33px;\n  height: 41px;\n}\n\ndiv.signal34-explore+p {\n  height: 16px;\n}\n\n.signupbusiness-form .form-group {\n  margin-bottom: 8px;\n}\n\n/*\nInvoices\n*/\n.medium_blank_row {\n  height: 10px;\n}\n\n.invoice-header {\n  background-color: #2288EE;\n  color: white;\n}\n\n.invoice-item {\n  width: 200px;\n  font-weight: bold;\n}\n\n.invoice-duration,\n.invoice-price {\n  width: 100px;\n  font-weight: bold;\n}\n\n#invoice-to-print {\n  backgroundColor: #f5f5f5;\n  width: 210mm;\n  minHeight: 297mm;\n  marginLeft: auto;\n  marginRight: auto;\n}\n\n.invoice_link,\n.edit_link {\n  cursor: pointer;\n}\n\ndiv.edit_link{\n  padding-top: 2px;\n  position: relative;\n  float: right;\n}\n\n.location-class {\n  display:inline-block;\n}\n\n.location-class:after{\n  content: \"*\";\n  color: red;\n}\n\n.location-class-left {\n  display:inline-block;\n}\n\n.location-class-right{\n  float: right;\n  padding-bottom: 0px;\n  margin-bottom: 0px;\n}\n\n.location-class-right .alert.alert-light.show {\n  padding-bottom: 0px;\n  margin-bottom: 8px;\n  margin-top: 0px;\n  border: 0px;\n  color: red;\n  background-color: transparent;\n}\n\n.location-class-right-options span{\n  float: right;\n  padding-left: 8px;\n  padding-bottom: 0px;\n  margin-bottom: 0px;\n  color: #888888;\n}\n\n.location-class-right-options span:hover{\n  cursor: pointer;\n}\n\n.edit-buttons {\n  margin-top: 10px;\n  float: right;\n  width: 100%;\n}\n\n.edit-buttons button {\n  margin-left: 5px;\n}\n\n.edit-buttons div{\n  float: right;\n}\n\n.page-item.active .page-link {\n  color: var(--signal34PageLinkColor);\n  background-color:var(--signal34PageLinkBackgroundColor);\n  border-color: var(--signal34PageLinkBorderColor);\n  cursor: default;\n  z-index: 0;\n}\n\na.page-link {\n  color: var(--signal34PageLinkBackgroundColor);\n  background-color:  var(--primaryBackgroundColor);\n}\n\n.page-item.disabled .page-link{\n  color: var(--signal34PageLinkDisabledTextColor);\n  background-color:  var(--signal34PageLinkDisabledBackgroundColor);\n}\n\n.page-link {\n  color: var(--signal34PageLinkBackgroundColor);\n}\n\na {\n  color: var(--signal34LinkColor);\n  text-decoration: none;\n}\n\n.form-control {\n  font-size: 14px;\n  color: var(--primaryTextColor);\n  background-color: var(--primaryBackgroundColor);\n}\n\n.form-control:hover,\n.form-control:focus {\n  color: var(--primaryTextColor);\n  background-color: var(--primaryBackgroundColor);\n}\n\n.signal34-bnt-default{\n  height: 34px;\n  font-size: 14px;\n  color: var(--signal34ButtonTextcolor);\n  background-color: var(--signal34ButtonBackgroundColor);\n  border-color: var(--signal34ButtonBorderColor);\n}\n\n.signal34-bnt-default.btn-outline-secondary:hover,\n.signal34-bnt-default.btn-outline-secondary:focus,\n.signal34-bnt-default.btn-outline-secondary:active:focus {\n  color: var(--signal34ButtonTextcolor);\n  background-color: var(--signal34ButtonHoverBackgroundColor);\n  border-color:  var(--signal34ButtonHoverBorderColor);\n  box-shadow: none;\n}\n\n.signal34-bnt-primary{\n  height: 34px;\n  font-size: 14px;\n  color: #fff;\n  background-color: #337ab7;\n  border-color: #337ab7;\n}\n\n.signal34-bnt-primary.btn-primary:hover,\n.signal34-bnt-primary.btn-primary:focus,\n.signal34-bnt-primary.btn-primary:active:focus {\n  color:#fff;\n  background-color:#286090;\n  border-color:#204d74;\n  box-shadow: none;\n}\n\n.dropdown-item:active {\n  color: var(--signal34ActionsMenuColor);\n  background-color: var(--signal34DropDownItemBackgroundColor);\n}\n\n.dropdown-item:focus, .dropdown-item:hover {\n  color: var(--signal34ActionsMenuColor);\n  text-decoration: none;\n  background-color: var(--signal34DropDownItemBackgroundColor);\n}\n\n.dropdown-item{\n  color: var(--signal34ActionsMenuColor);\n}\n\n.modal-add-content .modal-dialog {\n  margin: 30px auto;\n}\n\n.modal-embed-content .modal-dialog {\n  margin: 30px auto;\n}\n\n@media (min-width: 680px){\n  .modal-add-content .modal-dialog {\n    max-width: 600px;\n  }\n  .modal-embed-content .modal-dialog {\n    max-width: 600px;\n  }\n}\n.modal-title {\n  font-size: 18px;\n  font-family: \"Helvetica\";\n}\n\n.modal-header .close span {\n  font-size: 21px;\n  font-weight: 700;\n  line-height: 1;\n  color: var(--signal34ModalCloseColor);\n  text-shadow: 0 1px 0 #fff;\n}\n\n.alert.alert-light.show {\n  font-size: 14px;\n  padding-bottom: 10px;\n  color: red;\n  margin-top: 5px;\n  margin-bottom: 10px;\n  padding-top: 0px;\n  padding-left: 0px;\n  padding-right: 0px;\n  border-color: transparent;\n  background-color: transparent;\n}\n\n.signal34-popover-error{\n  color: red;\n}\n\na:not([href]).invoice_link {\n  color: var(--signal34LinkColor);\n}\n\na:not([href]).invoice_link {\n  color: var(--signal34LinkColor);\n}\n\n.dropdown-menu.show {\n  background-color: var(--primaryBackgroundColor);\n  color: var(--primaryTextColor);\n  border-color: var(--signal34ActionsMenuBorderColor);\n}\n\n.dropdown-menu {\n  min-width: 5rem;\n}\n\n.notes-counter-chars{\n  color:#999;\n  float: right;\n  font-size: 14px;\n  font-weight: normal;\n  padding-top: 3px;\n  margin: 0px;\n}\n\n.no-lr-padding {\n  padding-left: 4px;\n  padding-right: 4px;\n}\n\n/*\n  Update Method Payment\n*/\n.signal34-update-payment-container {\n  width: fit-content;\n}\n\n.signal34-update-payment-button-container {\n  display: block;\n  float: right;\n  padding-left: 15px;\n}\n\n.login-indent {\n  text-indent: 5.5em;\n}\n\n/* Desktop*/\n@media only screen and (min-width: 680px) {\n  .signal34-bnt-sign-in.btn-primary{\n    font-size: 14px;\n    color: #fff;\n    background-color: #337ab7;\n    border-color: #337ab7;\n    padding-left: 8px;\n    padding-right: 8px;\n    padding-top: 5px;\n    position: relative;\n    top: 50%;\n    text-align: center;\n    width: 95px;\n    height: 30px;\n    margin-left: 18px;\n    margin-right: 18px;\n    font-weight: bold;\n    -webkit-transform: translateY(-50%);\n    -ms-transform: translateY(-50%);\n    transform: translateY(-50%);\n    z-index: 3;\n  }\n}\n\n.signal34-bnt-sign-in.btn-primary:hover,\n.signal34-bnt-sign-in.btn-primary:focus,\n.signal34-bnt-sign-in.btn-primary:active:focus {\n  color:#fff;\n  background-color:#286090;\n  border-color:#204d74;\n  box-shadow: none;\n}\n\n/* for mobile*/\n@media only screen and (max-width: 679px) {\n  .signal34-bnt-sign-in.btn-primary{\n    font-size: 14px;\n    color: #fff;\n    background-color: #337ab7;\n    border-color: #337ab7;\n    padding-left: 8px;\n    padding-right: 8px;\n    padding-top: 5px;\n    position: relative;\n    top: 50%;\n    text-align: center;\n    width: max-content;\n    height: 30px;\n    margin-left: 5px;\n    margin-right: 5px;\n    font-weight: bold;\n    -webkit-transform: translateY(-50%);\n    -ms-transform: translateY(-50%);\n    transform: translateY(-50%);\n    z-index: 3;\n  }\n}\n\n/*share Dialog*/\n.share-row {\n  float: left;\n  width: 100%;\n  display: block;\n  padding: 5px;\n}\n\n.share-label {\n  float: left;\n  display: block;\n  width: 10%;\n  padding: 5px;\n}\n\n.share-input {\n  float: left;\n  display: block;\n  width: 80%;\n  padding-right: 15px;\n}\n\n.share-button {\n  float: right;\n  display: block;\n  width: 10%;\n}\n\n.share-social-icons {\n  width: 100%;\n  display: block;\n}\n\n.share-dialog {\n  display: block;\n  padding: 10px;\n}\n\n.share-social-button {\n  padding: 2px;\n  float: left;\n}\n\n.share-social-icon {\n  fill: rgb(117, 117, 117);\n}\n\n.share-input .form-control[readonly] {\n  color:rgb(117, 117, 117);\n  background: white\n}\n\n/* for mobile*/\n@media only screen and (max-width: 679px) {\n  .share-label {\n    float: left;\n    display: block;\n    width: 15%;\n  }\n  \n  .share-input {\n    float: left;\n    display: block;\n    width: 65%;\n  }\n  \n  .share-button {\n    float: right;\n    display: block;\n    width: 20%;\n  } \n }\n\n .embed-row {\n  padding-top: 8px;\n }\n\n /* datepicker*/\n .DayPicker-Months {\n   background-color: var(--primaryBackgroundColor);\n }\n\n .DayPicker-Day:hover,\n .DayPicker-Day:focus {\n   color: var(--signal34DatePickerDayColorFocus)\n }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
